<mat-progress-bar class="progress-margin login-container" color="primary" *ngIf="loading" mode="indeterminate"></mat-progress-bar>
<div class="card-container mat-elevation-z1">
    <div class="card-content">
        <mat-spinner *ngIf="loadingReservationService || addingPractice" matSuffix [diameter]="20"></mat-spinner>
        <div *ngIf="
        !loadingReservationService &&
        !addingPractice &&
        getAllServiceReservations.length > 0
      " class="margin-botton-medium">
            <mat-chip-list>
                <mat-chip [ngStyle]="{
            backgroundColor:
              serviceReservation.principalPracticeRegionServiceColor()
          }" (click)="loadServiceReservation(serviceReservation.Index)" *ngFor="let serviceReservation of getAllServiceReservations">
                    {{ serviceReservation.principalPracticeRegionReservationName() }}
                    <mat-icon (click)="onRemoveServiceReservation(serviceReservation)">cancel</mat-icon>
                </mat-chip>
            </mat-chip-list>
            <mat-divider></mat-divider>
        </div>
        <form [formGroup]="reservationPracticeFormGroup">
            <mat-form-field class="medium-width margin-right-medium">
                <input type="text" #entity matInput placeholder="Entidad" (input)="onEntityChange()" formControlName="Entity" required [matAutocomplete]="autEntity" />
                <mat-autocomplete #autEntity="matAutocomplete" (optionSelected)="entitySelected($event.option.value)" [displayWith]="filterCompleteEntities.displayFn">
                    <mat-option *ngFor="let entity of filteredEntitiesOptions | async" [value]="entity">
                        {{ entity.Name }}
                    </mat-option>
                </mat-autocomplete>
                <mat-error *ngIf="f.Entity.errors && f.Entity.errors.validAutoCompleteSelect">
                    Ingrese la entidad
                </mat-error>
            </mat-form-field>

            <mat-form-field class="medium-width">
                <input type="text" matInput placeholder="Plan" formControlName="Plan" (input)="onPlanChange()" [matAutocomplete]="autPlan" required />
                <mat-autocomplete #autPlan="matAutocomplete" (optionSelected)="planSelected($event.option.value)" [displayWith]="filterCompletePlans.displayFn">
                    <mat-option *ngFor="let plan of filteredPlansOptions | async" [value]="plan">
                        {{ plan.Name }}
                    </mat-option>
                </mat-autocomplete>
                <mat-error *ngIf="f.Plan.errors && f.Plan.errors.validAutoCompleteSelect">
                    Ingrese el plan
                </mat-error>
            </mat-form-field>

            <mat-form-field class="practice-width">
                <mat-spinner *ngIf="loadingPracticesRegion" matSuffix [diameter]="20"></mat-spinner>
                <input type="text" #practiceRegionReservation matInput placeholder="Práctica" formControlName="PracticeRegionReservation" [matAutocomplete]="autPractice" />
                <mat-autocomplete #autPractice="matAutocomplete" (optionSelected)="practiceSelected($event.option.value)" [displayWith]="displayPracticeRegionReservationFn">
                    <mat-option *ngFor="let practice of filterCompletePractices | async" [value]="practice">
                        {{ practice.PracticeRegionName }}
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>

            <button type="button" *ngIf="conf && conf.RequiredValidationInReserve" matTooltip="Validar" (click)="executeOnLineOperation()" mat-mini-fab>
        <mat-icon>cloud_done</mat-icon>
      </button>

            <button type="button" matTooltip="Nuevo servicio" *ngIf="enableCombo()" (click)="getNewServiceReservation()" mat-mini-fab>
        <mat-icon>add</mat-icon>
      </button>

            <button *ngIf="!ocultarPreparacion" type="button" matTooltip="Preparación" (click)="openPreparationDialog()" mat-mini-fab>
        <mat-icon>flag</mat-icon>
      </button>

            <mat-checkbox formControlName="IsInternation" style="margin-left: 10px" (change)="setInternation($event.checked)">
                Internado
            </mat-checkbox>

            <div class="box margin-right-small margin-botton-medium">
                <table mat-table class="practice-table margin-botton-medium" *ngIf="practicesRegionReservation.controls.length > 0" [dataSource]="practicesDataSource" formArrayName="PracticesRegionReservation">
                    <tr mat-header-row class="table-header" *matHeaderRowDef="displayPracticesColumns"></tr>
                    <tr mat-row class="table-cell" *matRowDef="
              let row;
              let i = index;
              columns: displayPracticesColumns
            "></tr>

                    <ng-container matColumnDef="Name">
                        <th mat-header-cell class="table-header" *matHeaderCellDef>
                            Práctica
                        </th>
                        <td mat-cell class="table-cell" *matCellDef="let row; let index = index" [formGroupName]="index">
                            {{ displayPracticeName(index) }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="Quantity">
                        <th mat-header-cell class="table-header" *matHeaderCellDef>
                            Cantidad
                        </th>
                        <td mat-cell class="table-cell" *matCellDef="let row; let index = index" [formGroupName]="index">
                            <input class="quantity-column" matInput type="number" min="1" formControlName="Quantity" />
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="buttons">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell class="table-cell" *matCellDef="let row; let index = index" [formGroupName]="index" (click)="$event.stopPropagation()">
                            <mat-icon class="cursor-default" (click)="onDeletePractice(index)">delete</mat-icon>
                        </td>
                    </ng-container>
                </table>
            </div>
            <div class="box margin-right-small">
                <table mat-table class="practice-table margin-botton-medium" *ngIf="practicesRegionAditionalReservation.controls.length > 0" [dataSource]="aditionalsDataSource" formArrayName="PracticesRegionAditionalReservation">
                    <tr mat-header-row class="table-header" *matHeaderRowDef="displayAditionalsColumns"></tr>
                    <tr mat-row class="table-cell" *matRowDef="
              let row;
              let i = index;
              columns: displayAditionalsColumns
            "></tr>

                    <ng-container matColumnDef="Select">
                        <th mat-header-cell class="table-header" *matHeaderCellDef></th>
                        <td mat-cell class="table-cell" *matCellDef="let row; let index = index" [formGroupName]="index">
                            <mat-checkbox (change)="practiceRegionAditionalReservationCheckChange(index)" formControlName="Select"></mat-checkbox>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="Name">
                        <th mat-header-cell class="table-header" *matHeaderCellDef>
                            Adicional
                        </th>
                        <td mat-cell class="table-cell" *matCellDef="let row; let index = index" [formGroupName]="index">
                            {{ displayAditionalPracticeName(index) }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="Quantity">
                        <th mat-header-cell class="table-header" *matHeaderCellDef>
                            Cantidad
                        </th>
                        <td mat-cell class="table-cell" *matCellDef="let row; let index = index" [formGroupName]="index">
                            <input class="quantity-column" matInput type="number" min="1" formControlName="Quantity" />
                        </td>
                    </ng-container>
                </table>
            </div>
            <div class="box">
                <table mat-table class="practice-table margin-botton-medium" *ngIf="setSuppliesReservation.controls.length > 0" [dataSource]="setSuppliesDataSource" formArrayName="SetSuppliesReservation">
                    <tr mat-header-row class="table-header" *matHeaderRowDef="displaySetSuppliesColumns"></tr>
                    <tr mat-row class="table-cell" *matRowDef="
              let row;
              let i = index;
              columns: displaySetSuppliesColumns
            "></tr>

                    <ng-container matColumnDef="Select">
                        <th mat-header-cell class="table-header" *matHeaderCellDef></th>
                        <td mat-cell class="table-cell" *matCellDef="let row; let index = index" [formGroupName]="index">
                            <mat-checkbox formControlName="Select"></mat-checkbox>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="Name">
                        <th mat-header-cell class="table-header" *matHeaderCellDef>
                            Set insumo
                        </th>
                        <td mat-cell class="table-cell" *matCellDef="let row; let index = index" [formGroupName]="index">
                            {{ displaySetSuppliesName(index) }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="Quantity">
                        <th mat-header-cell class="table-header" *matHeaderCellDef>
                            Cantidad
                        </th>
                        <td mat-cell class="table-cell" *matCellDef="let row; let index = index" [formGroupName]="index">
                            <input class="quantity-column" matInput type="number" min="1" formControlName="Quantity" />
                        </td>
                    </ng-container>
                </table>
            </div>
        </form>
    </div>
    <div class="clearfix">
        <div class="pull-right margin-right-medium">
            <button class="card-inline" type="button" (click)="reservationWizardService.cancel()" mat-button>
        CANCELAR
      </button>
        </div>
        <div class="card-footer">
            <button mat-button color="primary" matStepperPrevious>ANTERIOR</button>
            <button color="primary" mat-flat-button matStepperNext [disabled]="loadingReservationService || addingPractice" type="submit">
        SIGUIENTE
      </button>
        </div>
    </div>
</div>
